"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCultureQueuedMutation = setCultureQueuedMutation;
exports.setInitialSettings = setInitialSettings;
exports.setDefaultSalesOrganisation = setDefaultSalesOrganisation;
exports.updateWizardSettings = updateWizardSettings;
exports.resetUserSettings = resetUserSettings;
const GQLCachePatch = __importStar(require("gql-cache-patch"));
const GraphQLMutations = __importStar(require("../graphql-mutations"));
function setCultureQueuedMutation(settings, userProfileId) {
    const settingsKey = `UserSettingsCultureType;settings-culture:${userProfileId}`;
    const cachePatches = [];
    if (settings.language) {
        const languageKey = `LanguageType;${settings.language}`;
        cachePatches.push(GQLCachePatch.updateField(settingsKey, "language", languageKey));
    }
    if (settings.currency) {
        const currencyKey = `CurrencyType;${settings.currency}`;
        cachePatches.push(GQLCachePatch.updateField(settingsKey, "currency", currencyKey));
    }
    if (settings.locale) {
        const localKey = `CurrencyType;${settings.locale}`;
        cachePatches.push(GQLCachePatch.updateField(settingsKey, "locale", localKey));
    }
    return {
        document: GraphQLMutations.setUserSettingsCultureMutation,
        variables: {
            userSettingsCulture: settings
        },
        optimisticCachePatches: cachePatches
    };
}
function setInitialSettings(culture, activeAmountProfileId, climate) {
    return {
        document: GraphQLMutations.setInitialSettingsMutation,
        variables: {
            amountProfileId: activeAmountProfileId,
            userSettingsCulture: culture,
            userSettingsClimate: climate
        }
    };
}
function setDefaultSalesOrganisation(defaultSalesOrganisationCode, userProfileId) {
    const cacheKey = `UserSettingsSalesType;settings-sale-${userProfileId}`;
    return {
        document: GraphQLMutations.setUserSettingsSalesMutation,
        variables: {
            userSettingsSales: {
                defaultSalesOrganisationCode
            }
        },
        optimisticCachePatches: [
            GQLCachePatch.updateField(cacheKey, "defaultSalesOrganisation", defaultSalesOrganisationCode)
        ]
    };
}
function updateWizardSettings(lastCreatedSystemType, lastSelectedLabels, userProfileId) {
    const cacheKey = `WizardSettingsType;wizard-settings-${userProfileId}`;
    return {
        document: GraphQLMutations.updateWizardSettingsMutation,
        variables: {
            wizardSettings: {
                lastCreatedSystemType,
                lastSelectedLabels
            }
        },
        optimisticCachePatches: [
            GQLCachePatch.updateField(cacheKey, "lastCreatedSystemType", lastCreatedSystemType),
            GQLCachePatch.updateField(cacheKey, "lastSelectedLabels", lastSelectedLabels)
        ]
    };
}
function resetUserSettings() {
    return {
        document: GraphQLMutations.resetUserSettingsMutation,
        variables: {}
    };
}
//# sourceMappingURL=optimistic-cache-instructions.js.map